module.exports = __webpack_public_path__ + "static/img/2.9703c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msbl/2.jpg
// module id = a4Au
// module chunks = 1